import React from 'react';

import { ServiceCreationFormBuilderFieldFragmentProps } from './ServiceCreationFormBuilderFieldFragment.props';
import { ServiceCreationFormBuilderMenu } from '../../../../../components/molecules/ServiceCreationFormBuilderMenu';
import { useGetServiceTemplates } from '../../../../../queries/service-template-query';

export const ServiceCreationFormBuilderFieldFragment: React.FC<ServiceCreationFormBuilderFieldFragmentProps> = ({
  showErrors,
  preSelectedData,
  onPreSelectedData
}) => {
  const getServiceTemplatesQuery = useGetServiceTemplates();

  return (
    <ServiceCreationFormBuilderMenu
      error={showErrors}
      options={getServiceTemplatesQuery.data || []}
      value={preSelectedData}
      onChange={onPreSelectedData}
    />
  );
};
